import PropTypes from 'prop-types'
import React from 'react'

const FontFamilyToken = ({ text, family, value }) => (
  <div className="token" style={{ fontFamily: family || value }}>
    { text }
  </div>
)

FontFamilyToken.propTypes = {
  text: PropTypes.string,
  family: PropTypes.string,
  value: PropTypes.string
}

export default FontFamilyToken
